module.exports = __webpack_public_path__ + "assets/img/audience3.04d14989.svg";